import { DoorLockState, PressureMode, TemperatureMode } from 'dto/settings/enums';

import Enums from '../../base/enums';
import airdomeState from './AirdomeState';
import changeRequest from './ChangeRequest';
import lightState from './LightState';
import logLevel from './LogLevel';
import notificationChannel from './NotificationChannel';
import user from './user';

const enums: Enums = {
  user,
  notificationChannel,
  airdomeState,
  temperatureModes : {
    [TemperatureMode.Auto]: 'Auto',
    [TemperatureMode.Comfort]: 'Komfort',
    [TemperatureMode.Cutback]: 'Nieder',    
    disabled: 'Deaktiviert'
  },
  pressureModes: {
    [PressureMode.Maximum]: 'Maximal',
    [PressureMode.Normal]: 'Normal',
  },
  logLevel,
  lightState,
  changeRequest,
  doorLockState: {
    [DoorLockState.Auto]: {
      short: 'Auto',
      full: 'Auto'
    },
    [DoorLockState.Unlocked]: {
      short: 'Ent.',
      full: 'Entsperrt'
    },
    [DoorLockState.Locked]: {
      short: 'Ges.',
      full: 'Gesperrt'
    }
  }
};

export default enums;
